export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Medium.1c5a4d41.woff";